module.exports = __webpack_public_path__ + "static/media/16UNODC27.87d317a3.jpg";